//  # Auth API calls
// src/api/auth.js
import apiClient from './client';

export const authAPI = {
  // Send OTP
  sendOTP: async ({ mobile }) => {          // ← destructure here
    const response = await apiClient.post('auth', { mobile });
    return response.data;
  },
  // Verify OTP
  verifyOTP: async (userId, otp) => {
    const response = await apiClient.post(`auth/verify/${userId}`, { otp });
    return response.data;
  },

  // Get user profile
  getProfile: async () => {
    const response = await apiClient.get('me');
    return response.data;
  },

  updateProfile: async (profileData) => {
  const response = await apiClient.put('me', profileData);
  return response.data;
},

};

// ─── Auth token helper ────────────────────────────────────────────────────────
export const getAuthToken = () => {
  try {
    const userData = JSON.parse(localStorage.getItem("userData") || "{}");
    return (
      userData?.activeTokens?.slice(-1)[0]?.token ||
      userData?.accessToken ||
      userData?.access_token ||
      null
    );
  } catch {
    return null;
  }
};